import { get, put, destroy } from 'utils/fetchRequest';

/**
 * Public: бүх тохиргоо нэг flat объектоор
 * @param {string} lang - 'mn' | 'en'
 * @returns {Promise<{address, phone, email, ...}>}
 */
export const getCompanyInfo = async (lang = 'mn') => {
    try {
        return await get(`company-info?lang=${lang}`);
    } catch (err) {
        return { error: err };
    }
};

/**
 * Admin: бүтэн item-аар бүгдийг авах
 */
export const getCompanyInfoList = async () => {
    try {
        return await get('company-info/admin');
    } catch (err) {
        return { error: err };
    }
};

export const getCompanyInfoItem = async (key) => {
    try {
        return await get(`company-info/${key}`);
    } catch (err) {
        return { error: err };
    }
};

/**
 * Нэг key-г upsert
 */
export const upsertCompanyInfo = async (key, data) => {
    try {
        return await put(`company-info/${key}`, data);
    } catch (err) {
        return { error: err };
    }
};

/**
 * Олон key-г нэг дор bulk upsert
 * @param {Array<{key, value, valueEn, description}>} items
 */
export const bulkUpsertCompanyInfo = async (items) => {
    try {
        return await put('company-info', { items });
    } catch (err) {
        return { error: err };
    }
};

export const deleteCompanyInfo = async (key) => {
    try {
        return await destroy(`company-info/${key}`);
    } catch (err) {
        return { error: err };
    }
};
